export const parseMessage = (message: string | object) => {
    try {
        return typeof message === 'string' ? JSON.parse(message) : message;
    } catch (error) {
        return null;
    }
};
